import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;

const getParticipantes = async (municipio = null) => {
  const endpoint = "/api/financiero/participantes";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: municipio ? { municipio } : {}
  });
  return response.data;
};

const getProductos = async () => {
  const endpoint = "/api/financiero/fin_productos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getMunicipios = async (departamento = null) => {
  const endpoint = "/api/financiero/municipios";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: departamento ? { departamento } : {}
  });
  return response.data;
};

const getDepartamentos = async () => {
  const endpoint = "/api/financiero/departamentos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getProyectos = async () => {
  const endpoint = "/api/financiero/proyectos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

export {
  getParticipantes,
  getProductos,
  getMunicipios,
  getDepartamentos,
  getProyectos
};